import Vue from 'vue';
import VueRouter from 'vue-router';
import { canNavigate } from '@/libs/acl/routeProtection';
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils';
import pages from './routes/pages';
import user from './routes/user';
import settings from './routes/settings';
import equity_bond from './routes/equity-bond';
import equity from './routes/equity';
import bond from './routes/bond';
import fxsfs from './routes/fxsfs';
import fxOptions from './routes/fx-options';
import transfers from './routes/transfers';
import account_creation from './routes/account-creation';
import onboarding from './routes/onboarding';
import security_creation from './routes/security-creation';
import journals from './routes/journals';
import futureContracts from './routes/future-contracts';
import reports from './routes/reports';
import deposit from './routes/deposit';
import hosts, { isAppHost, isOnboardingHost } from '@/config/hosts';



Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/views/Home.vue'),
      meta: {
        Permission: 'no_permission_required',
      },
    },

    ...pages,
    ...user,
    ...settings,
    // ...equity_bond,
    ...equity,
    ...bond,
    ...fxsfs,
    ...fxOptions,
    ...transfers,
    ...account_creation,
    ...onboarding,
    ...security_creation,
    ...journals,
    ...futureContracts,
    ...reports,
    ...deposit,

    {
      path: '*',
      redirect: 'error-404',
    },
  ],
});

router.beforeEach((to, _, next) => {

  // The client onboarding page is served from its own domain, the rest of the application
  // from the main one. Anything on the wrong host is sent across; local hosts are untouched.
  const isOnboardingRoute = to.name === 'client-onboarding';
  if (isOnboardingHost() && !isOnboardingRoute) {
    window.location.replace(`https://${hosts.appHost}${to.fullPath}`);
    return;
  }
  if (isAppHost() && isOnboardingRoute && hosts.onboardingDomainLive) {
    window.location.replace(`${hosts.onboardingBase}${to.fullPath}`);
    return;
  }

  const isLoggedIn = isUserLoggedIn();

  if (!canNavigate(to)) {
    if (!isLoggedIn) return next({ name: 'auth-login' });
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData();
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null));
  }

  if (isLoggedIn) {
    const userData = JSON.parse(localStorage.getItem('userData'));
    const userPerms = JSON.parse(localStorage.getItem('userPerms'));
    if (to.meta.requiresInfinaReport && userData.role !== 'supermanager' && userData.infina_report != 1) {
      return next('/');
    }
    if (to.meta.requiresIntesaReport && userData.role !== 'supermanager' && userData.intesa_report != 1) {
      return next('/');
    }
    if (to.meta.requiresAzimutReport && userData.role !== 'supermanager' && userData.azimut_report != 1) {
      return next('/');
    }
    if (to.meta.requiresKareInfinaReport && userData.role !== 'supermanager' && userData.kare_infina_report != 1) {
      return next('/');
    }
    if (userData.role === 'supermanager') {
      return next();
    } else {
      if (to.meta.Permission === 'no_permission_required') {
        return next();
      } else {
        if (userPerms.includes(to.meta.Permission) == false) {
          next({ name: 'misc-not-authorized' });
        } else {
          return next();
        }
      }
    }
  } else {
    return next();
  }
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = 'none';
  }
});

export default router;
